import { useDesktopNavigation } from '@components/navbar/desktop/DesktopNavigationContext'
import { PanoramaIcon } from '@components/navbar/icons'
import { useIsWideLayout } from '@hooks/useMediaQuery.ts'
import useTypedTranslation from '@hooks/useTypedTranslation'
import { useArePanoramasAvailable } from '@state/panorama.ts'
import { routesFactory } from '@utils/routes.ts'

import NavItem from './NavItem'

function PanoramaNavItem() {
  const { t } = useTypedTranslation()
  const { storeId, scanId, isActive } = useDesktopNavigation()
  const arePanoramasAvailable = useArePanoramasAvailable()
  const isWideLayout = useIsWideLayout()

  // only show on desktop
  if (!isWideLayout) return null

  // Only show if there are panoramas
  if (!arePanoramasAvailable) return null

  return (
    <NavItem
      to={routesFactory.panorama(storeId, scanId)}
      label={t('panorama.title')}
      isActive={isActive('panorama')}
      icon={<PanoramaIcon size={20}/>}
    />
  )
}

export default PanoramaNavItem